import { BuilderDocumentDimensions, BuilderDocument, isPrintDocument } from '../builderDocument';
import { BuilderDocumentFormat } from '../builderDocumentFormat';
import { swapWidthAndHeight } from '../../geometry/geometry2d';

export class BuilderPrintDocument extends BuilderDocument {
    public format = BuilderDocumentFormat.print;

    public pages: BuilderPrintDocumentPage[] = [];
}

export type BuilderPrintDocumentPageOrientation = 'landscape' | 'portrait';

export interface BuilderPrintDocumentPage {
    layerIds: number[];
    orientation: BuilderPrintDocumentPageOrientation;
}

export function getPageOrientationFromDimensions(
    dimensions: { width: number; height: number } | undefined,
): 'landscape' | 'portrait' {
    return dimensions && dimensions.width > dimensions.height ? 'landscape' : 'portrait';
}

export function initialisePages(document: BuilderPrintDocument): void {

    document.pages ||= [
        {
            layerIds: document.layers.map(layer => layer.id),
            orientation: getPageOrientationFromDimensions(document.dimensions),
        },
    ];
}

export function isPageRotated(document: BuilderPrintDocument, pageIndex: number): boolean {
    const documentOrientation = getPageOrientationFromDimensions(document.dimensions);

    const pageOrientation = document.pages[pageIndex].orientation || documentOrientation;
    const isRotated = documentOrientation !== pageOrientation;
    return isRotated;
}

export function getPageDimensions(
    document: BuilderDocument,
    pageIndex: number,
    targetDocumentDimensions?: BuilderDocumentDimensions,
): BuilderDocumentDimensions {
    const documentDimensions = document.dimensions;

    if (!isPrintDocument(document)) {
        return documentDimensions;
    }

    // eslint-disable-next-line no-param-reassign
    targetDocumentDimensions ||= documentDimensions;

    if (isPageRotated(document, pageIndex)) {
        // eslint-disable-next-line no-param-reassign
        targetDocumentDimensions = {
            ...swapWidthAndHeight(targetDocumentDimensions),
            unit: targetDocumentDimensions.unit,
        };
    }

    return targetDocumentDimensions;
}
